import { warnIfOfflineNoCache } from '@school-manage/utils/offline';
import { createFileRoute } from '@tanstack/react-router';

import { TaskDetailError } from './-components/error/TaskDetailError';
import { TaskDetailSkeleton } from './-components/pending/TaskDetailSkeleton';
import { TaskDetail } from './-components/TaskDetail';
import { useTaskDetail } from './-logic/useTaskDetail';
import { TaskDetailContext } from './-logic/useTaskDetailContext';

export const Route = createFileRoute('/_authed/task/$taskId')({
  beforeLoad: ({ context: { queryClient }, location, params: { taskId } }) => {
    warnIfOfflineNoCache(location, [
      queryClient.getQueryData(['task-detail', { taskId }]),
    ]);
  },
  component: TaskDetailPage,
  errorComponent: TaskDetailError,
  pendingComponent: TaskDetailSkeleton,
});

function TaskDetailPage() {
  return (
    <TaskDetailContext.Provider value={useTaskDetail()}>
      <TaskDetail />
    </TaskDetailContext.Provider>
  );
}
